import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import VideosModal from 'component/video/VideosModal'

const REMOVE = 'VIDEOS_REMOVE'
const REMOVE_ALL = 'REMOVE_ALL'
const UPDATE = 'VIDEOS_UPDATE'
const VIEW = 'VIDEOS_VIEW'
let modalType = REMOVE

class VideosTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      videoModal: false,
      video: {},
      totalSelected: 0,
      videosSelected: [],
      videosSelectedIndex: [],
      lastVideoSelected: {},
    }

    this.openRemoveModal = this.openRemoveModal.bind(this)
    this.openUpdateModal = this.openUpdateModal.bind(this)
    this.openViewModal = this.openViewModal.bind(this)
    this.toogleModal = this.toogleModal.bind(this)
    this.renderVideosModal = this.renderVideosModal.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleUpdate = this.handleUpdate.bind(this)
    this.clearEmptySlots = this.clearEmptySlots.bind(this)
    this.shouldRenderButtons = this.shouldRenderButtons.bind(this)
    this.handleUnmarkAll = this.handleUnmarkAll.bind(this)
    this.handleMarkAll = this.handleMarkAll.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.renderRows = this.renderRows.bind(this)
  }

  openRemoveModal = (video) => {
    modalType = REMOVE
    this.setState({ video })
    this.toogleModal()
  }

  openRemoveAllModal = () => {
    modalType = REMOVE_ALL
    this.toogleModal()
  }

  openUpdateModal = (video) => {
    modalType = UPDATE
    this.setState({ video })
    this.toogleModal()
  }

  openUpdateModalFromEdit = (video) => {
    modalType = UPDATE
    this.setState({ video })
  }

  openViewModal = (video) => {
    modalType = VIEW
    this.setState({ video })
    this.toogleModal()
  }

  openViewModalFromEdit = (video) => {
    modalType = VIEW
    this.setState({ video })
  }

  toogleModal() {
    this.setState({ videoModal: !this.state.videoModal })
  }

  renderStatus = (video) => {
    const { translate } = this.props

    /* istanbul ignore else */
    if (video.startDate && video.endDate) {
      /* istanbul ignore else */
      if (moment(video.endDate).isBefore(moment())) {
        return (
          <span>
            {translate('videos.hidden')}{' '}
            {moment(video.endDate).format('DD/MM/YYYY')}
          </span>
        )
      }
      if (
        moment(video.endDate).isAfter(moment()) &&
        moment(video.startDate).isBefore(moment())
      ) {
        return (
          <span>
            {translate('videos.publishedUntil')}{' '}
            {moment(video.endDate).format('DD/MM/YYYY')}
          </span>
        )
      }
      if (moment(video.startDate).isAfter(moment())) {
        return (
          <strong>
            {translate('videos.published')}{' '}
            {moment(video.startDate).format('DD/MM/YYYY')}
          </strong>
        )
      }
    }
    return '-'
  }

  renderVideosModal() {
    const { videoModal } = this.state
    const { translate } = this.props
    const { video } = this.state

    /* istanbul ignore else */
    if (!videoModal) {
      return
    }

    let props = {}

    /* istanbul ignore else */
    if (modalType === VIEW) {
      props = {
        modalType: VIEW,
        translate,
        closeModal: this.toogleModal,
        editModal: this.openUpdateModalFromEdit,
        video,
      }
    } else if (modalType === UPDATE) {
      props = {
        modalType: UPDATE,
        translate,
        closeModal: this.toogleModal,
        viewModal: this.openViewModalFromEdit,
        initialValues: video,
        onSubmit: this.handleUpdate,
      }
    } else if (modalType === REMOVE) {
      props = {
        modalType: REMOVE,
        translate,
        closeModal: this.toogleModal,
        onSubmit: this.handleDelete,
      }
    } else if (modalType === REMOVE_ALL) {
      props = {
        modalType: REMOVE,
        translate,
        closeModal: this.toogleModal,
        onSubmit: this.handleDeleteAll,
      }
    }

    return <VideosModal {...props} />
  }

  handleDeleteAll = () => {
    const { handleRemoveAll } = this.props

    const lsVideos = this.clearEmptySlots()

    handleRemoveAll(lsVideos)
    this.handleUnmarkAll()
    this.toogleModal()
  }

  handleUnmarkAll() {
    const { setRenderButtons } = this.props
    setRenderButtons(false)

    this.setState({ videosSelected: [], totalSelected: 0 })

    const { videosSelectedIndex } = this.state

    /* istanbul ignore else */
    if (!videosSelectedIndex) {
      return
    }

    for (let i = 0; i < videosSelectedIndex.length; i++) {
      document.getElementById(videosSelectedIndex[i]).checked = false
    }

    this.setState({ videosSelectedIndex: [] })
  }

  handleMarkAll() {
    const { setRenderButtons, videos } = this.props
    setRenderButtons(true)

    const videosSelected = []
    const videosSelectedIndex = []
    const totalSelected = videos.length

    for (let i = 0; i < totalSelected; i++) {
      videosSelected[i] = videos[i]
      videosSelectedIndex[i] = i
      document.getElementById(i).checked = true
    }

    this.setState({
      videosSelected,
      videosSelectedIndex,
      totalSelected,
    })
  }

  shouldRenderButtons() {
    const { setRenderButtons } = this.props

    const lsVideos = this.clearEmptySlots()
    const totalSelected = lsVideos.length

    if (totalSelected > 0) {
      setRenderButtons(true)
    } else {
      setRenderButtons(false)
    }

    this.setState({ totalSelected })
  }

  clearEmptySlots() {
    const { videosSelected } = this.state

    const lsVideos = []
    /* istanbul ignore else */
    if (videosSelected) {
      for (let i = 0; i < videosSelected.length; i++) {
        /* istanbul ignore else */
        if (videosSelected[i]) {
          lsVideos.push(videosSelected[i])
        }
      }
    }

    return lsVideos
  }

  handleClick(index, video) {
    /* istanbul ignore else */
    if (typeof video === 'undefined') {
      return
    }

    const { checked } = document.getElementById(index)

    const { videosSelected, videosSelectedIndex } = this.state

    if (checked) {
      videosSelected[index] = video
      videosSelectedIndex.push(index)
    } else {
      delete videosSelected[index]
    }

    this.setState({
      videosSelected,
      videosSelectedIndex,
    })

    this.shouldRenderButtons()
  }

  handleDelete() {
    const { handleRemove } = this.props
    const { video } = this.state

    handleRemove(video)
    this.handleUnmarkAll()
    this.toogleModal()
  }

  handleUpdate(values) {
    const { onSubmit } = this.props

    onSubmit(values)
    this.handleUnmarkAll()
    this.toogleModal()
  }

  renderRows(video, index) {
    return (
      <tr key={index}>
        <td className='align-center checkbox-width'>
          <input
            id={index}
            type='checkbox'
            name='select'
            value={index}
            onClick={() => this.handleClick(index, video)}
          />
        </td>
        <td className='align-left hidden-column overflow-hidden-column overflow-column-text'>
          {video.videoTitle ? video.videoTitle : '-'}
        </td>
        <td className='align-left overflow-hidden-column overflow-column-text'>
          {this.renderStatus(video)}
        </td>
        <td className='align-center'>
          <a
            id={`view-video-${index}`}
            role='button'
            className='margin-right'
            onClick={() => this.openViewModal(video)}
          >
            <i className='glyph glyph-eye icon-size' />
          </a>
          <a
            id={`edit-video-${index}`}
            role='button'
            className='margin-right'
            onClick={() => this.openUpdateModal(video)}
          >
            <i className='glyph glyph-pencil icon-size' />
          </a>
          <a
            id={`remove-video-${index}`}
            role='button'
            onClick={() => this.openRemoveModal(video)}
          >
            <i className='glyph glyph-grey glyph-trash-can icon-size' />
          </a>
        </td>
      </tr>
    )
  }

  render() {
    const { videos, translate, renderButtons } = this.props

    return (
      <div className='VideoTable'>
        <legend>{translate('videos.list-videos')}</legend>

        {renderButtons && (
          <Row className='margin-top-double margin-bottom width-100'>
            <Col xs={12} md={6} className='margin-bottom'>
              <div className='display-inline'>
                <span>
                  {`${this.state.totalSelected} ${translate(
                    'videos.selected'
                  )}  |  `}
                </span>

                <a onClick={this.handleMarkAll}>
                  {translate('option.selectAll')}
                </a>

                <span>{'  |  '}</span>

                <a onClick={this.handleUnmarkAll}>
                  {translate('option.cancelSelection')}
                </a>
              </div>
            </Col>

            <Col xs={12} md={3} className='float-right'>
              <button
                role='button'
                onClick={this.openRemoveAllModal}
                className='button button-danger button-full align-center'
              >
                {translate('option.removeSelected')}
              </button>
            </Col>
          </Row>
        )}

        <table className='table table-zebra margin-top table-layout-fixed'>
          <thead>
            <tr>
              <th className='align-center checkbox-width' />
              <th className='align-left hidden-column overflow-hidden-column'>
                {translate('videos.nmVideo')}
              </th>
              <th className='align-left overflow-hidden-column'>
                {translate('videos.status')}
              </th>
              <th className='align-center overflow-hidden-column'>
                {translate('videos.actions')}
              </th>
            </tr>
          </thead>
          <tbody>{videos.map(this.renderRows)}</tbody>
        </table>

        {this.renderVideosModal()}
      </div>
    )
  }
}

VideosTable.propTypes = {
  videos: PropTypes.array.isRequired,
  translate: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
  renderButtons: PropTypes.bool.isRequired,
  setRenderButtons: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleRemoveAll: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

export default VideosTable
